<template>
  <div class="living-options-properties">
    <div class="row">
      <div class="col-12">
        <div class="properties">
          <h3>Properties</h3>
          <button class="btn btn-sm btn-primary mb-4" @click="addProperty">
            Add Property
          </button>
          <div class="row mb-2">
            <div class="col-4">
              <div class="status-option">
                <input
                  type="checkbox"
                  id="active"
                  value="Active"
                  v-model="filterActiveStates"
                />
                <label class="status-option__label" for="active">Active</label>
              </div>

              <div class="status-option">
                <input
                  type="checkbox"
                  id="inactive"
                  value="Inactive"
                  v-model="filterActiveStates"
                />
                <label class="status-option__label" for="inactive"
                  >Inactive</label
                >
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-12">
              <label>Filter By Status</label>
              <div
                v-for="status in filterStatusOptions"
                class="row col-4"
                :key="status"
              >
                <input
                  type="checkbox"
                  :id="status"
                  :value="status"
                  v-model="filterStatuses"
                />
                <label class="status-option__label" :for="status">
                  {{ status }}
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4">
              <label for="filterRelease">Filter By Release</label>
              <select
                class="form-control"
                name="filterRelease"
                v-model="filterReleaseId"
              >
                <option value="">All Releases</option>
                <option
                  v-for="subsection in subsectionsOrdered"
                  :value="subsection.id"
                >
                  {{ subsection.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2">
            <input
              class="form-control"
              type="text"
              v-model="propertiesFilterText"
              placeholder="Filter properties"
            />
          </div>
          <v-table
            :columns="[
              {
                label: 'Label',
                field: 'label',
              },
              {
                label: 'Status',
                field: 'status',
                options: {
                  sortable: true,
                  callback: function (row) {
                    filterByStatus(row);
                  },
                  return: function (fieldValue) {
                    if (fieldValue === 'Not Found') {
                      return '-';
                    } else {
                      switch (fieldValue) {
                        case 'Available':
                          return `<div class='status status--available table-link'>${fieldValue}</div>`;

                        case 'Coming Soon':
                          return `<div class='status status--coming-soon table-link'>${fieldValue}</div>`;

                        case 'On Hold':
                          return `<div class='status status--on-hold table-link'>${fieldValue}</div>`;

                        case 'Sold':
                          return `<div class='status status--sold table-link'>${fieldValue}</div>`;

                        case 'Builder Lots':
                          return `<div class='status status--builder-lots table-link'>${fieldValue}</div>`;

                        case 'Not Released':
                          return `<div class='status status--not-released table-link'>${fieldValue}</div>`;

                        default:
                          return `<div class='table-link'>${fieldValue}</div>`;
                      }
                    }
                  },
                },
              },
              {
                label: 'Price',
                field: 'price',
                options: {
                  sortable: true,
                  return: function (fieldValue) {
                    if (fieldValue === 'Not Found' || !fieldValue) {
                      return '-';
                    } else {
                      return fieldValue.toLocaleString('en-AU', {
                        style: 'currency',
                        currency: 'AUD',
                        maximumSignificantDigits: 10,
                      });
                    }
                  },
                },
              },

              {
                label: 'Subsection',
                field: 'subsection',
                options: {
                  sortable: true,
                  return: function (row) {
                    if (!row) {
                      return '-';
                    } else {
                      if (row.active) {
                        return `<a class='table-link' href='/live/subsections/${
                          row._id
                        }' target='_blank'>${stripTags(row.label)}</a>`;
                      } else {
                        return `<a title='Inactive' class='table-link table-link--inactive' href='/live/subsections/${
                          row._id
                        }' target='_blank'>${stripTags(row.label)}</a>`;
                      }
                    }
                  },
                },
              },
              {
                label: 'Living Option',
                field: 'livingOption',
                options: {
                  sortable: true,
                  return: function (row) {
                    if (!row) {
                      return '-';
                    } else {
                      if (row.active) {
                        return `<a class='table-link' href='/live/masterplan/${
                          row._id
                        }' target='_blank'>${stripTags(row.label)}</a>`;
                      } else {
                        return `<a title='Inactive' class='table-link table-link--inactive' href='/live/masterplan/${
                          row._id
                        }' target='_blank'>${stripTags(row.label)}</a>`;
                      }
                    }
                  },
                },
              },
              {
                label: 'Dwelling',
                field: 'dwelling',
                options: {
                  sortable: true,
                  return: function (row) {
                    if (!row) {
                      return '-';
                    }
                    if (row.active) {
                      return `<a class='table-link' href='/live/dwellings/${row._id}' target='_blank'>${row.label}</a>`;
                    } else {
                      return `<a title='Inactive' class='table-link table-link--inactive' href='/live/dwellings/${row._id}' target='_blank'>${row.label}</div>`;
                    }
                  },
                },
              },
            ]"
            :rows="filteredProperties"
            :show-active-toggle="activeUser.access.includes('live-toggle')"
            save-action="SAVE_PROPERTY"
            @edit="editProperty($event._id)"
            @clone="cloneProperty($event)"
            @delete="deleteProperty($event._id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VTable from "@/components/VTable";

export default {
  components: {
    VTable,
  },

  data() {
    return {
      propertiesFilterText: "",
      filterStatusOptions: [
        "Available",
        "Builder Lots",
        "Coming Soon",
        "On Hold",
        "Sold",
        "Not Released",
        "Unassigned",
      ],
      filterStatuses: [],
      filterActiveStates: [],
      filterReleaseId: "",
    };
  },

  computed: {
    ...mapGetters(["properties", "subsections"]),

    subsectionsOrdered() {
      return this.subsections.sort((a, b) => {
        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();

        if (labelA < labelB) {
          return -1;
        } else {
          return 1;
        }
      });
    },

    activeUser() {
      return this.$store.getters.user;
    },

    filteredProperties() {
      let filtered = this.properties.filter((property) =>
        property.label
          .toLowerCase()
          .includes(this.propertiesFilterText.toLowerCase())
      );

      if (this.filterStatuses.length) {
        filtered = filtered.filter((property) =>
          this.filterStatuses.includes(property.status)
        );
      }

      if (this.filterReleaseId) {
        filtered = filtered.filter(
          (property) => property.subsectionId === this.filterReleaseId
        );
      }

      if (this.filterActiveStates.length) {
        filtered = filtered.filter(
          (property) =>
            (this.filterActiveStates.includes("Active") && property.active) ||
            (this.filterActiveStates.includes("Inactive") && !property.active)
        );
      }

      return filtered;
    },
  },

  created() {
    this.$store.dispatch("FETCH_PROPERTIES");
    this.$store.dispatch("FETCH_SUBSECTIONS");
  },

  watch: {
    filterReleaseId() {
      // this.$route.query.filterReleaseId = this.filterReleaseId
      this.$router.push({ query: { filterReleaseId: this.filterReleaseId } });
    },
  },

  mounted() {
    if (this.$route.query.filterReleaseId) {
      this.filterReleaseId = this.$route.query.filterReleaseId;
    }
  },

  methods: {
    filterByStatus(row) {
      this.filterStatuses = [];
      this.filterStatuses.push(row.status);
    },

    navToSubsection(row) {
      this.$router.push(`/live/subsections/${row.subsectionId}`);
    },

    navToLivingOption(row) {
      if (row.livingOptionId) {
        this.$router.push(`/live/masterplan/${row.livingOptionId}`);
      }
    },

    navToDwelling(row) {
      if (row.dwellingId) {
        this.$router.push(`/live/dwellings/${row.dwellingId}`);
      }
    },

    async addProperty() {
      const newProperty = await this.$store.dispatch("ADD_NEW_PROPERTY");
      this.$store.dispatch("SAVE_PROPERTY", newProperty);
      this.editProperty(newProperty._id);
    },

    async cloneProperty(property) {
      const clonedProperty = await this.$store.dispatch(
        "CLONE_PROPERTY",
        property
      );
      this.$store.dispatch("SAVE_PROPERTY", clonedProperty);
    },

    deleteProperty(id) {
      if (confirm("Are you sure?")) {
        this.$store.dispatch("DELETE_PROPERTY", id);
      }
    },

    editProperty(id) {
      // this.$router.push(`/live/properties/${id}`);
      window.open(`/live/properties/${id}`, "_blank");
    },

    stripTags(htmlString) {
      if (!htmlString || typeof htmlString !== "string") return htmlString;

      return htmlString.replace(/<[^>]*>/g, "");
    },
  },
};
</script>
